import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axiosInstance from "../../hooks/axios";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import { LocationCharge } from "../../types/locationCharge";
import { formatMoney } from "../../utils/formatMoney";

export default function LocationChargeDetail() {
  const { id } = useParams();
  const [locationCharge, setLocationCharge] = useState<LocationCharge | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchLocationChargeData();
  }, [id]);

  const fetchLocationChargeData = async () => {
    try {
      const response = await axiosInstance.get(`/locationcharges/${id}`);
      setLocationCharge(response.data);
    } catch (error) {
      setError("Failed to fetch location charge data");
      console.error("Error fetching location charge:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatPrice = (price: number | string | null) => formatMoney(price);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!locationCharge) return <div>No data found</div>;

  return (
    <div className="space-y-6">
      <PageBreadcrumb pageTitle="Location Charge Details"  />

      <div className="flex flex-wrap items-center justify-end gap-3">
        <Link
          to={`/location-charges/edit/${id}`}
          className="inline-flex items-center justify-center rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-600"
        >
          Edit
        </Link>
      </div>

      <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-theme-sm dark:border-gray-800 dark:bg-white/[0.03] lg:p-6">
        <dl className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div>
            <dt className="text-sm font-medium text-gray-500">Post Code</dt>
            <dd className="mt-1 text-sm text-gray-900">
              {locationCharge.postCode}
            </dd>
          </div>

          <div>
            <dt className="text-sm font-medium text-gray-500">Price</dt>
            <dd className="mt-1 text-sm text-gray-900">
              {formatPrice(locationCharge.price)}
            </dd>
          </div>

          <div>
            <dt className="text-sm font-medium text-gray-500">Status</dt>
            <dd className="mt-1">
              <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                locationCharge.status ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
              }`}>
                {locationCharge.status ? 'Active' : 'Inactive'}
              </span>
            </dd>
          </div>
        </dl>
      </div>
    </div>
  );
} 